module.exports = __webpack_public_path__ + "static/media/user-prop-delete.90498894.svg";